import { Col, Row } from 'antd';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import styled from 'styled-components';
import { Redirect } from 'react-router';
import { CenteredFormContent, BannerDiv } from 'components/Layout/LoginLayout/LoginLayout.Style';
import EntrepreneurProjectDetailsView from 'components/CompanyProjects/EntrepreneurProjectDetailsView';

export interface Props extends RouteProps {
    children?: React.ReactNode;
}

export interface State { }

export default class EntrepreneurProjectDetailPage extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);


        this.state = {};
    }

    componentDidMount() {

    }

    render() {
        return <CenteredFormContent>
            <BannerDiv className={"project-list"}>
                <Row style={{ height: '100%' }}>
                </Row>
            </BannerDiv>
            <br />

            <Row type="flex" align="middle" justify="center">
                <Col span={21} offset={1}>
                    <EntrepreneurProjectDetailsView />
                </Col>
            </Row>
        </CenteredFormContent>;
    }
}
